export default __webpack_public_path__ + "static/media/ic-add.1ac95a46.svg";